import { StedIcon } from "@/assets/icons";
import { Link } from "react-router-dom";
import BgImage from "@/assets/img/bg-image.png";

export const AuthLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className='flex min-h-screen bg-primary'>
      {/* Left side - Auth form */}
      <div className='w-full md:w-1/2 flex items-center justify-center p-4'>
        <div
          className='w-full max-w-md bg-white border-gray-300 rounded-lg shadow-lg px-4'
          // style={{
          //   marginTop: "2rem",
          //   marginBottom: "1.5rem",
          // }}
        >
          <div className='w-full mx-auto flex flex-col gap-10 py-8 px-4'>
            <Link to='/' className='flex gap-3 justify-center items-center'>
              <StedIcon size='md' />
            </Link>
            {children}
          </div>
        </div>
      </div>

      {/* Right side - Image with referral info */}
      <div
        className='hidden md:block md:w-1/2 bg-primary bg-no-repeat bg-center bg-contain'
        style={{
          backgroundImage: `url(${BgImage})`,
        }}
      ></div>
    </div>
  );
};
